export default __webpack_public_path__ + "static/ctaModule_cloud_top_desktop-ee8dace454a70378128b1ae9eb7b0de6.png";